import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@com-delta-idp/mnx-ui-kit';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { LoginHelpScreenComponent } from './login-help-screen.component';

@NgModule({
  declarations: [LoginHelpScreenComponent],
  imports: [CommonModule, ButtonModule, LoginHeaderModule],
  exports: [LoginHelpScreenComponent]
})
export class LoginHelpScreenModule {}
